import _asyncToGenerator from "C:/Users/Fanni/OneDrive/Asztali g\xE9p/brandfashion/EmptyYS-2020/vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from 'vuelidate';
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
export default {
  mixins: [validationMixin],
  data: function data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: '',
      isProcessing: false,
      errorMessage: ''
    };
  },
  activated: function activated() {
    this.$v.$reset();
  },
  methods: {
    closePopup: function closePopup() {
      this.$store.commit("setState", {
        key: "createAccountIsActive",
        value: false
      });
    },
    showLogin: function showLogin() {
      this.$store.commit("setState", {
        key: "createAccountIsActive",
        value: false
      });
      this.$store.commit("setState", {
        key: "loginIsActive",
        value: true
      });
    },
    createAccount: function createAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _email, firstName, lastName, password, account;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.$v.$touch();

                if (!_this.$v.$invalid) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.isProcessing = true;
                _email = _this.email, firstName = _this.firstName, lastName = _this.lastName, password = _this.password;
                _context.next = 8;
                return _this.$swell.account.create({
                  email: _email,
                  firstName: firstName,
                  lastName: lastName,
                  password: password,
                  emailOptin: true
                });

              case 8:
                account = _context.sent;
                _this.isProcessing = false;

                if (account.id) {
                  _this.isProcessing = false;

                  _this.$store.commit('setState', {
                    key: 'customerLoggedIn',
                    value: true
                  });

                  _this.$store.dispatch('showNotification', {
                    message: _this.$t('account.createAccount.success')
                  });

                  _this.$router.push(_this.localePath('/account/orders/'));
                } else if (account.email && account.email.code === 'UNIQUE') {
                  _this.$store.dispatch('showNotification', {
                    message: _this.$t('account.createAccount.alreadyExists'),
                    type: 'error'
                  });
                }

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                _this.$store.dispatch('showNotification', {
                  message: _context.t0.message || _this.$t('account.createAccount.error'),
                  type: 'error'
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }))();
    }
  },
  validations: {
    firstName: {
      required: required,
      maxLength: maxLength(40)
    },
    lastName: {
      required: required,
      maxLength: maxLength(40)
    },
    email: {
      required: required,
      email: email
    },
    password: {
      required: required,
      minLength: minLength(6)
    }
  }
};